import VehiclesSearchCount from "./VehiclesSearchCount";

export default VehiclesSearchCount;
